import HelperService from '@/services/HelperService';
import axios from '@axios';

const baseUrl = 'api/v1/visits';
const helperService = new HelperService();
export default {
  getVisitsPaginated(filters) {
    const filtersWithVisitType = { ...filters, visitType: 'in-cell' };
    const queryString = helperService.buildSearchQueryString(filtersWithVisitType);
    return axios.get(`${baseUrl}/prison/paginated${queryString}`);
  },
  getPreviousInCellVisits(visitorUserId) {
    return axios.get(`${baseUrl}/visitor-user/${visitorUserId}/previous-visits`);
  },
  rejectRequest(id, dto) {
    return axios.post(`${baseUrl}/reject/${id}`, dto);
  },
  getVisit(id) {
    return axios.get(`${baseUrl}/single-visit/${id}`);
  },
  approveRequest(id, dto) {
    return axios.post(`${baseUrl}/approve/${id}`, dto);
  },
  cancelVisit(id, dto) {
    return axios.post(`${baseUrl}/cancel/${id}`, dto);
  },
  bookVisitForVisitor(dto) {
    return axios.post(`${baseUrl}/in-cell/book-visit`, dto);
  },
  getInCellVisitStats() {
    return axios.get(`${baseUrl}/prison/stats?isInCellCall=true`);
  },
  removeAdditionalVisitor(visitId, additionalVisitorId, rejectionReason) {
    return axios.post(`${baseUrl}/additional-visitor/remove/${visitId}`, {
      additional_visitor_id: additionalVisitorId,
      rejection_reason: rejectionReason,
    });
  },
  addAdditionalVisitor(visitId, additionalVisitorId) {
    return axios.post(`${baseUrl}/additional-visitor/add/${visitId}`, {
      additional_visitor_id: additionalVisitorId,
    });
  },
  getAdditionalVisitors(visitId) {
    return axios.get(`${baseUrl}/${visitId}/additional-visitors`);
  },
  refundInCellKioskItems(visitId, dto) {
    return axios.post(`${baseUrl}/refund-kiosk-items/${visitId}`, dto);
  },
  fullRefundInCellKioskItems(visitId) {
    return axios.post(`${baseUrl}/refund-kiosk-items/full/${visitId}`);
  },
}
